import { ModalTypes } from 'application/providers/ModalProvider/consts';

import { DeviceTypes } from 'domain/api/graphql/generated';

import { TEXTS } from './texts';
import { DeviceTypesInFlow, PlayerTypesInFlow, VideoDeviceType } from '../types';
import { PlayerRadioType } from './types';

export const DEVICES_IN_FLOW = [
  DeviceTypes.Android,
  DeviceTypes.Androidbox,
  DeviceTypes.BoomSpeaker,
  DeviceTypes.Desktop,
  DeviceTypes.Ios,
  DeviceTypes.Webplayer,
];

export const DEVICE_TO_PLAYER_TYPE: Record<DeviceTypesInFlow | VideoDeviceType, PlayerTypesInFlow> = {
  [DeviceTypes.Android]: PlayerTypesInFlow.MOBILE,
  [DeviceTypes.Androidbox]: PlayerTypesInFlow.ANDROIDBOX,
  [DeviceTypes.BoomSpeaker]: PlayerTypesInFlow.BOOM_SPEAKER,
  [DeviceTypes.Desktop]: PlayerTypesInFlow.DESKTOP,
  [DeviceTypes.Ios]: PlayerTypesInFlow.MOBILE,
  [DeviceTypes.Webplayer]: PlayerTypesInFlow.WEBPLAYER,
  [VideoDeviceType.Video]: PlayerTypesInFlow.VIDEOPLAYER,
};

export const PLAYER_TO_DEVICE_TYPE: Record<PlayerTypesInFlow, DeviceTypesInFlow | VideoDeviceType> = {
  [PlayerTypesInFlow.MOBILE]: DeviceTypesInFlow.ANDROID,
  [PlayerTypesInFlow.ANDROIDBOX]: DeviceTypesInFlow.ANDROIDBOX,
  [PlayerTypesInFlow.BOOM_SPEAKER]: DeviceTypesInFlow.BOOM_SPEAKER,
  [PlayerTypesInFlow.DESKTOP]: DeviceTypesInFlow.DESKTOP,
  [PlayerTypesInFlow.WEBPLAYER]: DeviceTypesInFlow.WEBPLAYER,
  [PlayerTypesInFlow.VIDEOPLAYER]: VideoDeviceType.Video,
};

export const PLAYER_TEXT_TYPE: Record<PlayerTypesInFlow, Omit<PlayerRadioType, 'type'>> = {
  [PlayerTypesInFlow.WEBPLAYER]: {
    title: TEXTS.WEBPLAYER_TITLE,
    description: TEXTS.WEBPLAYER_DESCRIPTION,
  },
  [PlayerTypesInFlow.MOBILE]: {
    title: TEXTS.MOBILE_TITLE,
    description: TEXTS.MOBILE_DESCRIPTION,
  },
  [PlayerTypesInFlow.DESKTOP]: {
    title: TEXTS.DESKTOP_TITLE,
    description: TEXTS.DESKTOP_DESCRIPTION,
  },
  [PlayerTypesInFlow.BOOM_SPEAKER]: {
    title: TEXTS.BOOM_SPEAKER_TITLE,
    description: TEXTS.BOOM_SPEAKER_DESCRIPTION,
    ruByOnly: true,
  },
  [PlayerTypesInFlow.ANDROIDBOX]: {
    title: TEXTS.SBER_BUSINESS_PLAYER_TITLE,
    description: TEXTS.SBER_BUSINESS_PLAYER_DESCRIPTION,
    ruByOnly: true,
  },
  [PlayerTypesInFlow.VIDEOPLAYER]: {
    title: TEXTS.VIDEO_PLAYER_TITLE,
    description: TEXTS.VIDEO_PLAYER_DESCRIPTION,
  },
};

export const PLAYER_NAME_TYPE: Record<DeviceTypes | VideoDeviceType, string> = {
  [DeviceTypes.AliceSpeaker]: TEXTS.ALICE_TITLE,
  [DeviceTypes.Android]: TEXTS.MOBILE_TITLE,
  [DeviceTypes.Androidbox]: TEXTS.SBER_BUSINESS_PLAYER_TITLE,
  [DeviceTypes.BoomSpeaker]: TEXTS.BOOM_SPEAKER_TITLE,
  [DeviceTypes.Desktop]: TEXTS.DESKTOP_TITLE,
  [DeviceTypes.Desktopbox]: TEXTS.RPI_TITLE,
  [DeviceTypes.Ios]: TEXTS.MOBILE_TITLE,
  [DeviceTypes.Musicbox]: TEXTS.MUSICBOX_TITLE,
  [DeviceTypes.Netcore]: TEXTS.NETCORE_TITLE,
  [DeviceTypes.Webplayer]: TEXTS.WEBPLAYER_TITLE,
  [DeviceTypes.Pavo]: TEXTS.PAVO_TITLE,
  [VideoDeviceType.Video]: TEXTS.VIDEO_PLAYER_TITLE,
};

export const MODAL_MODE_BY_DEVICE_TYPE: Record<PlayerTypesInFlow, ModalTypes> = {
  [PlayerTypesInFlow.WEBPLAYER]: ModalTypes.STREAM_BIND_SUCCESS,
  [PlayerTypesInFlow.MOBILE]: ModalTypes.MOBILE_PLAYER_DOWNLOAD,
  [PlayerTypesInFlow.BOOM_SPEAKER]: ModalTypes.SBERBOOM_REQUEST,
  [PlayerTypesInFlow.DESKTOP]: ModalTypes.DESKTOP_PLAYER_DOWNLOAD,
  [PlayerTypesInFlow.ANDROIDBOX]: ModalTypes.SBERBUSSINESS_REQUEST,
  [PlayerTypesInFlow.VIDEOPLAYER]: ModalTypes.CHOOSE_VIDEO_PLAYER,
};
